import { useEffect } from 'react';

import {
  setIsDashboardMenuVisibleAction,
  setIsFullMenuVisibleAction,
} from '@sternum/web/features/appContainerWithMenu/slice';
import { store, useAppDispatch, useAppSelector } from '@sternum/web/store';

export function useAutoExpand() {
  const dispatch = useAppDispatch();
  const isAutoExpanded = useAppSelector((state) => state.appContainerWithMenu.isAutoExpanded);

  useEffect(() => {
    if (!isAutoExpanded) {
      return;
    }

    const widthThreshold = 768;
    const state: {
      isExpanded?: boolean;
      isDashboardMenuVisibleLastState?: boolean;
    } = { isExpanded: undefined };

    const observer = new ResizeObserver(() => {
      if (state.isExpanded !== true && window.innerWidth > widthThreshold) {
        const isDashboardMenuVisible = state.isDashboardMenuVisibleLastState ?? false;
        const isFullMenuVisible = !isDashboardMenuVisible;

        dispatch(setIsFullMenuVisibleAction(isFullMenuVisible));
        dispatch(setIsDashboardMenuVisibleAction(isDashboardMenuVisible));

        state.isExpanded = true;
      } else if (state.isExpanded !== false && window.innerWidth < widthThreshold) {
        const reduxState = store.getState();

        dispatch(setIsFullMenuVisibleAction(false));
        dispatch(setIsDashboardMenuVisibleAction(false));

        state.isExpanded = false;
        state.isDashboardMenuVisibleLastState = reduxState.appContainerWithMenu.isDashboardMenuVisible;
      }
    });

    observer.observe(window.document.body);

    return () => {
      observer.disconnect();
    };
  }, [dispatch, isAutoExpanded]);
}
